import { toastsActions } from '@zola-helpers/client';

import * as ActionType from '../types/website/PageActionTypes';
import { getPageVisibility } from '../../selectors/website/websiteSelectors';
import FeatureFlags from '../../util/featureFlags';


function requestPages() {
  return {
    type: ActionType.REQUEST_PAGES
  };
}

function receivePages(json) {
  return {
    type: ActionType.RECEIVE_PAGES,
    payload: {
      pages: json
    }
  };
}

function receiveHiddenPageSuggestions(json) {
  return {
    type: ActionType.RECEIVE_HIDDEN_PAGE_SUGGESTIONS,
    payload: {
      hiddenSuggestions: json
    }
  };
}

function receivePage(json) {
  return {
    type: ActionType.RECEIVE_PAGE,
    payload: {
      page: json
    }
  };
}

export const activatePage = activePage => (dispatch) => {
  dispatch({ type: ActionType.ACTIVATE_PAGE, activePage });
};

export function fetchPages() {
  return (dispatch) => {
    dispatch(requestPages());
    return fetch('/web-api/v1/cms/page/list',
      {
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(receivePages(json)));
  };
}

export function fetchHiddenPageSuggestions() {
  return dispatch => (
    fetch('/web-api/v1/cms/page/hiddensuggestions',
      {
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(receiveHiddenPageSuggestions(json)))
  );
}

export function reorderPages() {
  return (dispatch, getState) => (
    fetch('/web-api/v1/cms/page/list/reorder',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(getState().website.pages.orderedIds)
      })
      .then(response => response.json())
      .then(json => dispatch(receivePages(json)))
  );
}

export const movePage = (oldIndex, newIndex) => (dispatch) => {
  dispatch({ type: ActionType.MOVE_PAGE, oldIndex, newIndex });
  dispatch(reorderPages());
};

export function updatePageVisibility(pageId) {
  return (dispatch, getState) => (
    fetch(`/web-api/v1/cms/page/id/${pageId}/hidden`,
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
          hidden: getPageVisibility(getState(), pageId)
        })
      })
      .then(response => response.json())
      .then(json => dispatch(receivePage(json)))
      .then(() => dispatch(toastsActions.positive({ headline: `Page ${getPageVisibility(getState(), pageId) ? 'Inactive' : 'Active'}` })))
  );
}

export const togglePage = id => (dispatch) => {
  dispatch({ type: ActionType.TOGGLE_PAGE, payload: { id } });
  dispatch(updatePageVisibility(id));
};

export function requestProfileImage() {
  return {
    type: ActionType.REQUEST_PROFILE_IMAGE
  };
}

export function receiveProfileImage(response) {
  const profileImage = response.profile_image;
  return {
    type: ActionType.RECEIVE_PROFILE_IMAGE,
    payload: profileImage
  };
}

export function toggleHiddenPageSuggestion(pageId, hidden) {
  return dispatch => (
    fetch(`/web-api/v1/cms/page/id/${pageId}/hidden`,
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
          hidden
        })
      })
      .then(response => response.json())
      .then(() => dispatch(toastsActions.positive({ headline: `Page ${hidden ? 'Hidden' : 'Visible'}` })))
  );
}

export function getProfileImage() {
  return (dispatch) => {
    dispatch(requestProfileImage());
    return fetch('/website-nav/web-api/v1/registry/get',
      {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
      })
      .then(response => response.json())
      .then(json => dispatch(receiveProfileImage(json)));
  };
}

export function updatePage(pageView, showNotification = true) {
  return dispatch => (
    fetch('/web-api/v1/cms/page',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(pageView)
      })
      .then(response => response.json())
      .then(json => dispatch(receivePage(json)))
      .then((data) => {
        if (showNotification) {
          const pageName = data.payload.page && data.payload.page.menu_title;
          const notifyText = pageName && FeatureFlags.get('isCmsPageFormV2')
            ? `${pageName} changes saved`
            : 'Page Updated';

          dispatch(toastsActions.positive({ headline: notifyText }))
        }
      })
  );
}

export const updatePageSilently = (pageView) => updatePage(pageView, false)

export function bulkUpdateCmsPageVisibility(pages) {
  return dispatch => (
    fetch('/web-api/v1/cms/page/list/bulkupdate',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(pages)
      })
      .then(() => dispatch(fetchPages()))
  );
}



// WEBPACK FOOTER //
// ./src/actions/website/PageActions.js